import {NavLink} from "react-router-dom";
import {AuthContext} from "../contexts/AuthContext";
import {useContext} from "react";

function Navbar() {
	const {user, setUser, setToken} = useContext(AuthContext);

	return (
		<div className={"navbar navbar-expand-lg navbar-light"} style={{backgroundColor: '#f8f9fa'}}>
			<div className={"container-fluid px-4"}>
				<a href="#" className={"navbar-brand"}>
					<img src={"/logo.png"} alt="Datamundi Accounting Portal" width="200" style={{marginRight: '6px'}} />
					Accounting
				</a>
				<button className="navbar-toggler" type="button" data-bs-toggle="collapse"
						data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
						aria-expanded="false" aria-label="Toggle navigation">
					<span className="navbar-toggler-icon"></span>
				</button>
				<div className="collapse navbar-collapse" id="navbarSupportedContent">
					<ul className="navbar-nav mx-auto mb-2 mb-lg-0">
						{/* <li className={"nav-item dropdown"}>
							<a className={"nav-link dropdown-toggle" } href="#" id="navbarDropdownDashboard" role="button"
							   data-bs-toggle="dropdown" aria-expanded="false">
								Dashboard
							</a>
							<ul className="dropdown-menu" aria-labelledby="navbarDropdownDashboard">
								<li>
									<NavLink className="dropdown-item" to="/dashboard/overview" activeClassName={"active"}>Overview</NavLink>
								</li>
								<li>
									<NavLink className="dropdown-item" to="/dashboard/indirectCosts" activeClassName={"active"}>Indirect costs</NavLink>
								</li>
							</ul>
						</li> */}
						<li className="nav-item">
							<NavLink className="nav-link" to="/dashboard/overview" activeClassName={"active"}>Dashboard</NavLink>
						</li>
						<li className="nav-item">
							<NavLink className="nav-link" to="/customerTasks" activeClassName={"active"}>Projects</NavLink>
						</li>
						<li className="nav-item dropdown">
							<a className={"nav-link dropdown-toggle"} href="#" id="navbarDropdown" role="button"
							   data-bs-toggle="dropdown" aria-expanded="false">
								Payments
							</a>
							<ul className="dropdown-menu" aria-labelledby="navbarDropdown">
								<li>
									<NavLink className="dropdown-item" to="/payments/unpaidInvoices" activeClassName={"active"}>Unpaid invoices</NavLink>
								</li>
								<li>
									<NavLink className="dropdown-item" to="/payments/paidInvoices" activeClassName={"active"}>Paid invoices</NavLink>
								</li>
							</ul>
						</li>
						<li className="nav-item">
							<NavLink className="nav-link" to="/purchaseOrders" activeClassName={"active"}>POs</NavLink>
						</li>
					</ul>
					<ul className={"navbar-nav mb-2 mb-lg-0"}>
						<li className="nav-item dropdown">
							<a className={"nav-link dropdown-toggle"} href="#" id="navbarProfileDropdown" role="button"
							   data-bs-toggle="dropdown" aria-expanded="false">
								My profile
							</a>
							<ul className="dropdown-menu dropdown-menu-end" aria-labelledby="navbarProfileDropdown">
                                {user.rights.includes("admin") && <li><a className="dropdown-item" href={`https://admin.datamundi.${process.env.REACT_APP_node_env}`}>Admin</a></li>}
                                {user.rights.includes("manager") && <li><a className="dropdown-item" href={`https://manager.datamundi.${process.env.REACT_APP_node_env}`}>Manager</a></li>}
                                {user.rights.includes("pm") && <li><a className="dropdown-item" href={`https://pm.datamundi.${process.env.REACT_APP_node_env}`}>PM</a></li>}
                                {user.rights.includes("qa") && <li><a className="dropdown-item" href={`https://qa.datamundi.${process.env.REACT_APP_node_env}`}>QA</a></li>}
                                {user.rights.includes("freelancer") && <li><a className="dropdown-item" href={`https://freelancer.datamundi.${process.env.REACT_APP_node_env}`}>Freelancer</a></li>}
                                {user.rights.includes("customer") && <li><a className="dropdown-item" href={`https://customer.datamundi.${process.env.REACT_APP_node_env}`}>Customer</a></li>}
                                <li><hr className="dropdown-divider" /></li>
								<li>
									<NavLink className="dropdown-item" to="/profile/settings" activeClassName={"active"}>Settings</NavLink>
								</li>
								<li><a href="/AIDA_Accounting_User_Guide.pdf" target={"_blank"} className={"dropdown-item"}>Help</a></li>
								<li>
                                    <form method="post" action={`${process.env.REACT_APP_endPoint}/v1/auth/logout`}>
                                        <button type="submit" className="dropdown-item">Sign out</button>
                                    </form>
								</li>
							</ul>
						</li>
					</ul>
				</div>
			</div>
		</div>
	);
}

export default Navbar;
